var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":function($event){return _vm.$emit('on-click')}}},[(_vm.clicked)?_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"spinner"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }